export default "__VITE_ASSET__8b45f4f8__"